// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VCYYQ","icon":"styles_icon__qsMCc","cartBackButton":"styles_cartBackButton__kQ5ry","home":"styles_home__OMnov"};